// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__rWeu3","imageSection":"ErrorPage_imageSection__ttMjr"};